export const getInputStyleByAmountLength = (
  amount: string,
  smaller?: boolean,
): React.CSSProperties => {
  const length = amount?.length || 0;

  const BASE_FONT_SIZE = smaller ? 40 : 54;

  const BASE_LENGTH = 4;

  const DECREASE_RATE = smaller ? 3 : 4;

  const MIN_FONT_SIZE = smaller ? 18 : 20;

  let fontSize: number;

  if (length <= BASE_LENGTH) {
    fontSize = BASE_FONT_SIZE;
  } else {
    const extraChars = length - BASE_LENGTH;

    fontSize = Math.max(
      MIN_FONT_SIZE,
      BASE_FONT_SIZE - extraChars * DECREASE_RATE,
    );
  }

  return {
    fontSize: `${fontSize}px`,
  };
};
